import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-akte',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-akte.component.html',
  styleUrl: './tekst-akte.component.scss',
})
export class TekstAkteComponent {}
